(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/toConsumableArray', 'babel-runtime/helpers/slicedToArray', '../util/array', '../util/lang'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/toConsumableArray'), require('babel-runtime/helpers/slicedToArray'), require('../util/array'), require('../util/lang'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toConsumableArray, global.slicedToArray, global.array, global.lang);
    global.flow = mod.exports;
  }
})(this, function (exports, _toConsumableArray2, _slicedToArray2, _array, _lang) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.flow = undefined;

  var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * A function successively calling a list of functions.
   * @callback flowFunction
   * @memberof flow
   * @param {*} arg The starting value
   * @returns {*} The resulting value
   * @since 1.0.0
   */

  /**
   * Creates a function that will successively call all functions contained in <code>args</code>.<br/>
   * Each function is called with the result of the previous one.<br/>
   * Non functions <code>args</code> are tolerated and will be ignored.
   * @memberof core
   * @param {...(function|Array<function>)} args The functions to apply
   * @returns {flow.flowFunction} A function successively calling function <code>args</code>
   * @since 1.0.0
   */
  function flow() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var fns = (0, _array.flatten)(args).filter(function (fn) {
      return (0, _lang.isFunction)(fn);
    }).map(function (fn) {
      return fn.applier === undefined ? function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            obj = _ref2[0],
            appliedPaths = _ref2[1];

        return [fn(obj), appliedPaths];
      } : function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            obj = _ref4[0],
            appliedPaths = _ref4[1];

        return [fn.applier(obj, appliedPaths), [].concat((0, _toConsumableArray3.default)(appliedPaths), [fn.applier.path])];
      };
    });
    return function (obj) {
      var _fns$reduce = fns.reduce(function (acc, fn) {
        return fn(acc);
      }, [obj, []]),
          _fns$reduce2 = (0, _slicedToArray3.default)(_fns$reduce, 1),
          result = _fns$reduce2[0];

      return result;
    };
  }

  exports.flow = flow;
});